// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"7043d8b3","382":"0d2b3256","692":"fa1f2c3c"}[chunkId] + ".chunk.js";
};